import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Overlaytext from "../components/Overlaytext/Overlaytext";
const BlogPage = () => {
  const blogPosts = [
    {
      id: 1,
      title: "10 Essential Sales Metrics Every Business Should Track",
      excerpt:
        "Discover the key performance indicators that can transform your sales strategy and drive measurable results.",
      author: "Sarah Johnson",
      date: "December 15, 2024",
      category: "Sales Strategy",
      readTime: "5 min read",
      image: "📊",
    },
    {
      id: 2,
      title: "The Future of B2B Sales: Trends to Watch in 2025",
      excerpt:
        "Explore emerging trends and technologies that are reshaping the B2B sales landscape.",
      author: "Mike Chen",
      date: "December 10, 2024",
      category: "Industry Trends",
      readTime: "7 min read",
      image: "🚀",
    },
    {
      id: 3,
      title: "Building a High-Performing Sales Team: Best Practices",
      excerpt:
        "Learn how to recruit, train, and retain top sales talent for your organization.",
      author: "John Smith",
      date: "December 5, 2024",
      category: "Team Building",
      readTime: "6 min read",
      image: "👥",
    },
    {
      id: 4,
      title: "CRM Implementation: A Complete Guide",
      excerpt:
        "Everything you need to know about choosing and implementing the right CRM system.",
      author: "Emily Davis",
      date: "November 28, 2024",
      category: "Technology",
      readTime: "8 min read",
      image: "💻",
    },
    {
      id: 5,
      title: "Lead Generation Strategies That Actually Work",
      excerpt:
        "Proven methods for generating high-quality leads and converting them into customers.",
      author: "David Wilson",
      date: "November 20, 2024",
      category: "Lead Generation",
      readTime: "6 min read",
      image: "🎯",
    },
    {
      id: 6,
      title: "Sales Training: Investing in Your Team's Success",
      excerpt:
        "Why continuous sales training is crucial for long-term business growth.",
      author: "Lisa Brown",
      date: "November 15, 2024",
      category: "Training",
      readTime: "5 min read",
      image: "🎓",
    },
  ];

  const categories = [
    "All",
    "Sales Strategy",
    "Industry Trends",
    "Team Building",
    "Technology",
    "Lead Generation",
    "Training",
  ];

  return (
    <div className="App">
      <Header />

      {/* Hero Section */}
      <Overlaytext title="Blog" subtitle="Insights, tips, and strategies from our sales experts" backgroundImage=" https://images.unsplash.com/photo-1758873268877-3cd8ed329ed8?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=3132 " />

      {/* Featured Post */}
      <section className="featured-post">
        <div className="container">
          <div className="featured-content">
            <div className="featured-image">
              <div className="image-placeholder">📈</div>
            </div>
            <div className="featured-text">
              <span className="featured-badge">Featured</span>
              <h2>How to Increase Sales by 300% in 6 Months</h2>
              <p>
                A comprehensive case study showing how we helped a client
                achieve remarkable sales growth through strategic planning and
                execution.
              </p>
              <div className="featured-meta">
                <span className="author">By John Smith</span>
                <span className="date">December 20, 2024</span>
                <span className="read-time">10 min read</span>
              </div>
              <button className="btn btn-primary">Read Full Article</button>
            </div>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="blog-filter">
        <div className="container">
          <div className="filter-buttons">
            {categories.map((category) => (
              <button key={category} className="filter-btn">
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="blog-main">
        <div className="container">
          <div className="blog-grid">
            {blogPosts.map((post) => (
              <article key={post.id} className="blog-card">
                <div className="blog-image">
                  <div className="image-placeholder">{post.image}</div>
                  <span className="blog-category">{post.category}</span>
                </div>
                <div className="blog-content">
                  <h3>{post.title}</h3>
                  <p>{post.excerpt}</p>
                  <div className="blog-meta">
                    <span className="author">By {post.author}</span>
                    <span className="date">{post.date}</span>
                    <span className="read-time">{post.readTime}</span>
                  </div>
                  <button className="btn btn-secondary">Read More</button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="newsletter-section">
        <div className="container">
          <div className="newsletter-content">
            <h2>Stay Updated</h2>
            <p>
              Subscribe to our newsletter for the latest sales insights and tips
            </p>
            <form className="newsletter-form">
              <input
                type="email"
                placeholder="Enter your email address"
                required
              />
              <button type="submit" className="btn btn-primary">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;
